const QUALIFIED_DOMAINS_STORAGE_KEY = 'firms:qualified-domains';

export const readKnownQualifiedDomains = (): string[] => {
  try {
    const stored = localStorage.getItem(QUALIFIED_DOMAINS_STORAGE_KEY);
    return stored ? (JSON.parse(stored) as string[]) : [];
  } catch {
    return [];
  }
};

export const rememberQualifiedDomains = (values: string[]): string[] => {
  const merged = Array.from(new Set([...readKnownQualifiedDomains(), ...values.filter(Boolean)]));
  try {
    localStorage.setItem(QUALIFIED_DOMAINS_STORAGE_KEY, JSON.stringify(merged));
  } catch {
    // A full or unavailable storage only costs the suggestions, so the caller carries on.
  }
  return merged;
};
